import { ApiError } from "../api.js";
import { requestPasswordReset } from "../auth.js";
import { navigate } from "../app.js";

export async function render(container) {
  container.innerHTML = `
    <div class="mx-auto" style="max-width:26rem;">
      <h1 class="display-heading h3 mb-2">Reset your password</h1>
      <p class="text-slate">Enter the email address on your account and we'll send a link.</p>
      <form id="forgot-form" novalidate>
        <div class="mb-3">
          <label class="form-label" for="forgot-email">Email</label>
          <input type="email" class="form-control" id="forgot-email" autocomplete="email" required />
        </div>
        <div id="forgot-error" class="text-danger small mb-3 d-none"></div>
        <button type="submit" class="btn btn-primary w-100" id="forgot-submit">Send reset link</button>
      </form>
      <p class="text-center mt-3 mb-0"><a href="#/login">Back to sign in</a></p>
    </div>`;

  container.querySelector("#forgot-form").addEventListener("submit", async (e) => {
    e.preventDefault();
    const errorEl = container.querySelector("#forgot-error");
    const button = container.querySelector("#forgot-submit");
    errorEl.classList.add("d-none");

    const email = container.querySelector("#forgot-email").value.trim();
    if (!email) {
      errorEl.textContent = "Enter your email address.";
      errorEl.classList.remove("d-none");
      return;
    }

    button.disabled = true;
    button.textContent = "Sending...";
    try {
      const data = await requestPasswordReset(email);
      // Deliberately the same screen whether or not that address has an
      // account — echoing "no such user" here would undo the API's
      // careful refusal to confirm it.
      container.innerHTML = `
        <div class="dc-empty text-center py-5 mx-auto" style="max-width:26rem;">
          <i class="bi bi-envelope-check text-success" style="font-size:2.5rem;"></i>
          <h1 class="h4 mt-3">Check your inbox</h1>
          <p class="text-slate">${data?.message || "If that address has an account, a reset link is on its way."}</p>
          <p class="text-slate small">The link is good for one hour and can only be used once.</p>
          <button class="btn btn-outline-secondary mt-2" id="forgot-back">Back to sign in</button>
        </div>`;
      container.querySelector("#forgot-back").addEventListener("click", () => navigate("/login"));
    } catch (err) {
      errorEl.textContent = err instanceof ApiError ? err.message : "Something went wrong.";
      errorEl.classList.remove("d-none");
      button.disabled = false;
      button.textContent = "Send reset link";
    }
  });
}
